import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id 47194CCD-AF78-430F-AD95-4D564D6E1D18
 * name math-tan
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/math-tan.svg
 * tags
 * - Math 
 */
export const MathTanIcon = createSvgIcon(<><path d="M2,7V9H4V17H6V9H8V7H2M11,7A2,2 0 0,0 9,9V17H11V13H13V17H15V9A2,2 0 0,0 13,7H11M11,9H13V11H11V9M16,7V17H18V12L20,17H22V7H20V12L18,7H16Z" /></>, 'MathTanIcon');
export default MathTanIcon